<template>
  <div class="container mt-6">
    <vs-card :title="'Catálogos'">
      <vs-table :data="catalogs" stripe>
        <template slot="thead">
          <vs-th>Id</vs-th>
          <vs-th>Categoría</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="item in data" :key="item.id">
            <vs-td>
              <router-link
                :property="item"
                :to="`/risk-model/catalog/${item.id}/items?category=${item.category}`">{{ item.id }}</router-link>
            </vs-td>
            <vs-td>{{ item.category }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-card>

  </div>
</template>

<script>
import EditTextComponent from "@components/editText/EditTextComponent";
import {RiskModel} from "@/services/ModelRisk/RiskModel";

export default {
  name: "CatalogTypes",
  components: {EditTextComponent},
  data: () => ({
    catalogs: [],
    categories: [],
    showModal: false
  }),
  async mounted() {
    this.catalogs = await RiskModel
      .catalog()
      .categories()
  }
}
</script>

<style scoped>

</style>
